import { BaseModel } from './base-model';

import { size, filter, sumBy } from 'lodash';

export type IReceivingsStatus = 'complete' | 'draft' | 'unconfirmed';

/**
 * WiP model for receivings
 */
export class ReceivingsModel extends BaseModel {
  status: IReceivingsStatus;

  // TODO find out if it's necessary
  _id: string;
  id: string;

  docNumber: string;
  remarks: string;
  warehouseId: string;
  skus: any[];
  active: boolean;
  totalQty: number;
  supplierOrderReference: string[];

  // TODO add fields from receivings
  products?: {
    // TODO add fields in receivings.products
    buyPrice: number;
    price: number;
    suggestedRetailPrice: number;
    sku: any[];
  }[];

  // TODO find a way to represent the skus/products duality for receivings.
  // When created on /recevings, we set skus array which is remapped to
  // products by backend while saving

  constructor(originalValue?: Partial<ReceivingsModel>) {
    super(originalValue);
  }

  /**
   * Counts all products on the list that has price or buyPrice === 0
   * @return {number} number of relevant products
   */
  countUnpricedProducts() {
    return size(
      filter(
        this.products,
        (product) => product.price === 0 || product.buyPrice === 0,
      ),
    );
  }

  /**
   * Counts all products on the list.
   * @return {number} number of products
   */
  // TODO unit tests
  getTotalQty() {
    return sumBy(this.skus, 'qty');
  }

  /**
   * Sums up value price for all products on the list
   * @return {number} number of products
   */
  // TODO unit tests
  getTotalValuePrice() {
    return sumBy(this.skus, (sku) => {
      return sku.qty * sku.valuePrice;
    });
  }
}
